export function deleteCategory(data) {
    let { deleteCategoryRequest, deleteCategoryError, deleteCategoryResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/category/delete',
        this.createBundle('app/category/delete', { category: data }, this.POST, deleteCategoryRequest, deleteCategoryResult, deleteCategoryError)
    )
}
